/**
 * Strap Finder analytics.
 *
 * The Strap Finder is the store's primary conversion path (Brand -> Model -> Lug ->
 * Results -> Add to cart) and previously had zero instrumentation, so there was no way
 * to see where people drop off.
 *
 * This emits each funnel step through three channels, all of which are harmless no-ops
 * when the corresponding consumer isn't installed:
 *
 *   1. window.dataLayer  — picked up by GA4 / Google Tag Manager if/when they're added
 *   2. Shopify.analytics.publish — subscribable from a Shopify Custom Pixel
 *   3. a DOM CustomEvent ('sf:analytics') — for anything theme-local
 *
 * Usage:  window.sfTrack && window.sfTrack('strap_finder_step', { step: 2, brand: 'Omega' });
 */
(function () {
  if (window.sfTrack) return;

  function clean(payload) {
    var out = {};
    Object.keys(payload || {}).forEach(function (key) {
      var value = payload[key];
      if (value !== null && value !== undefined && value !== '') out[key] = value;
    });
    return out;
  }

  window.sfTrack = function (eventName, payload) {
    if (!eventName) return;
    var detail = clean(payload);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, detail));
    } catch (e) {}

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, detail);
      }
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('sf:analytics', {
        detail: Object.assign({ event: eventName }, detail)
      }));
    } catch (e) {}
  };
})();
